import { render, staticRenderFns } from "./review-item.vue?vue&type=template&id=34d7d5b0&scoped=true&"
import script from "./review-item.vue?vue&type=script&lang=js&"
export * from "./review-item.vue?vue&type=script&lang=js&"
import style0 from "./review-item.vue?vue&type=style&index=0&id=34d7d5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d7d5b0",
  null
  
)

export default component.exports